"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
exports.__esModule = true;
var DOMScript_1 = require("@/scripts/utils/DOMScript");
var rxjs_1 = require("rxjs");
var operators_1 = require("rxjs/operators");
var VideoBlock = /** @class */ (function () {
    function VideoBlock() {
    }
    VideoBlock.prototype.onLoadEach = function ($element) {
        if (!$element) {
            return;
        }
        var $imageVideoOverlay = $element.$(".video_overlay_image");
        var $videoIframe = $element.$("iframe");
        $imageVideoOverlay &&
            (0, rxjs_1.fromEvent)($imageVideoOverlay, "click")
                .pipe((0, operators_1.take)(1), (0, operators_1.tap)(function (e) { return e.preventDefault(); }))
                .subscribe(function (e) {
                var src = $videoIframe.dataset.src;
                $element.classList.add("played");
                $videoIframe.src += src + "&autoplay=1";
            });
    };
    VideoBlock = __decorate([
        (0, DOMScript_1.DOMBlock)({
            selector: ".VideoBlock",
            isElementArray: true
        })
    ], VideoBlock);
    return VideoBlock;
}());
new VideoBlock();
